// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"213":"3c6d4137","257":"a7ac031a","322":"7b6d8b2b","341":"50314e5d","510":"e3f5480b","527":"9de0889e","679":"3548f6c1","753":"5cfea686","761":"d3d9f493","914":"15b6bdf7","918":"2b1eaf7f","974":"e4fa9607"}[chunkId] + ".js";
};